//@flow
import React from "react";

export type SparklineIndicatorType = {
  rowHeight: number,
  periods: Array<{
    delta: number,
    descript: string,
    key: string,
    type: string,
    value: number,
  }>,
};

export default function sparklineIndicator({ rowHeight, periods }: SparklineIndicatorType) {
  const data = periods;
  let maxValue = 0;
  data.forEach(item => {
    if (item.value > maxValue) {
      maxValue = item.value;
    }
  });
  if (!rowHeight) rowHeight = 40;

  const padding = 4;
  const width = 100;
  const chartHeight = rowHeight - padding * 2;
  const chartWidth = width - padding * 2;
  const barWidth = chartWidth / data.length;
  const vectors = data
    .map((period: *, index: number) => {
      const yVector = padding + chartHeight - (chartHeight / maxValue) * parseFloat(period.value);
      return {
        x: padding + barWidth * index,
        y: isNaN(yVector) ? 0 : yVector,
      };
    })
    .reduce((acc: string, v: *) => `${acc} ${v.x},${v.y}`, "")
    .trim();

  return (
    <div className="d-flex align-items-center justify-content-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="d-flex"
        height={rowHeight + "px"}
        width={`${width}`}
      >
        <polyline fill="transparent" stroke="orange" strokeWidth="1" points={vectors} />
      </svg>
    </div>
  );
}
